import {inArray} from "@helpers/arrays";

export const investmentCities = [
    // {id: 259, fa_name: 'تهران', en_name: 'tehran'},
    //{id: 207, fa_name: 'مشهد', en_name: 'mashhad'},
    //{id: 262, fa_name: 'گلبهار', en_name: 'golbahar'},
    //{id: 3614, fa_name: 'چمستان', en_name: 'chamestan'},
    //{id: 1367, fa_name: 'نور', en_name: 'noor'},
    //{id: 1368, fa_name: 'نوشهر', en_name: 'noshahr'},
    //{id: 3159, fa_name: 'رویان', en_name: 'royan'},
    //{id: 1364, fa_name: 'محمودآباد', en_name: 'mahmodabad'},
    //{id: 1358, fa_name: 'سلمانشهر ( متل قو )', en_name: 'salmanshahr'},
    //{id: 1353, fa_name: 'تنکابن ( شهسوار )', en_name: 'tonekabon'},
    //{id: 308, fa_name: 'رشت', en_name: 'rasht'},
    //{id: 1355, fa_name: 'چالوس', en_name: 'chalus'},
    //{id: 1634, fa_name: 'آمل', en_name: 'amol'},
    //{id: 1351, fa_name: 'بابلسر', en_name: 'babolsar'},
    //{id: 3429, fa_name: 'کلارآباد', en_name: 'kelarabad'},
    //{id: 3972, fa_name: 'عباس آباد', en_name: 'abbasabad'},
    //{id: 4567, fa_name: 'نشتارود', en_name: 'neshtarud'},
    //{id: 1356, fa_name: 'رامسر', en_name: 'ramsar'},
    //{id: 4863, fa_name: 'چابکسر', en_name: 'chaboksar'},
];

/**
 * @param city_id {Number}
 *
 * @return Boolean
 * */
export function showDistrictsInInvestmentForm(city_id) {
    const hideDistrictInCity = [
        262, // گلبهار
        3614, // چمستان
    ];

    return !inArray(Number(city_id), hideDistrictInCity);
}

/**
 * @param city_id {Number}
 *
 * @return Boolean
 * */
export function showDealTypeByCity(city_id) {
    const cities = [
        207, // مشهد
    ];

    return inArray(Number(city_id), cities);
}